const CLIENT_VERSION = "1.01";
  
export default CLIENT_VERSION;